import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { orderService, CreateOrderPayload } from '../../services/order.service';

export const useOrders = () => {
    return useQuery({
        queryKey: ['orders'],
        queryFn: orderService.getOrders,
    });
};

export const useClientUnpaidOrders = () => {
    return useQuery({
        queryKey: ['client-unpaid-orders'],
        queryFn: orderService.getClientUnpaidOrders,
    });
};

export const useClientAcceptedOrders = () => {
    return useQuery({
        queryKey: ['client-accepted-orders'],
        queryFn: orderService.getClientAcceptedOrders,
    });
};

export const useTableUnpaidOrders = (tableId: string | undefined) => {
    return useQuery({
        queryKey: ['table-unpaid-orders', tableId],
        queryFn: () => orderService.getTableUnpaidOrders(tableId!),
        enabled: !!tableId,
    });
};

export const useCreateOrder = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (order: CreateOrderPayload) => orderService.createOrder(order),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['orders'] });
            queryClient.invalidateQueries({ queryKey: ['client-unpaid-orders'] });
        },
    });
};

export const useCreateBatchOrders = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (orders: CreateOrderPayload[]) => orderService.createBatchOrders(orders),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['orders'] });
            queryClient.invalidateQueries({ queryKey: ['client-unpaid-orders'] });
        },
    });
};
